import { render, staticRenderFns } from "./bookDialog.vue?vue&type=template&id=548a08a6&scoped=true"
import script from "./bookDialog.vue?vue&type=script&lang=js"
export * from "./bookDialog.vue?vue&type=script&lang=js"
import style0 from "./bookDialog.vue?vue&type=style&index=0&id=548a08a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "548a08a6",
  null
  
)

export default component.exports